export enum AlertNoticeLevel {
  Information,
  Warning,
  Danger,
  Upcoming
}
export enum EntityAlertType {
  CompanyDocumentFollowUp,
  OperativeDocumentFollowUp,
  TrainingRecordDocumentFollowUp,
  CompanyFollowUp,
  TrainingRecordFollowUp,
  OperativeFollowUp,
  DocumentReview,
  DocumentExpired,
  OperativeRisk
}

export const EntityAlertTypes = [
  { value: EntityAlertType.CompanyDocumentFollowUp, label: 'Enterprise Document'},
  {value: EntityAlertType.TrainingRecordDocumentFollowUp, label: 'Training Record Document'},
  {value: EntityAlertType.OperativeDocumentFollowUp, label: 'Operative Document'},
  { value: EntityAlertType.CompanyFollowUp, label: 'Enterprise'},
  {value: EntityAlertType.TrainingRecordFollowUp, label: 'Training Record'},
  {value: EntityAlertType.OperativeFollowUp, label: 'Operative'},
  {value: EntityAlertType.DocumentReview, label: 'Document Review'},
  {value: EntityAlertType.DocumentExpired, label: 'Document Expired'},
  {value: EntityAlertType.OperativeRisk, label: 'Operative Risk'},
];
export const AlertNoticeLevels = [
  {value: AlertNoticeLevel.Information, label: 'Information'},
  {value: AlertNoticeLevel.Warning, label: 'Warning'},
  {value: AlertNoticeLevel.Danger, label: 'Danger'},
];
export interface IAlertInfo {
  title: string;
  detailsHtml: string;
  canBeDismissed: boolean;
  directLink: string;
  linkText: string;
  followUpOn: string;
  alertLevel: AlertNoticeLevel;
  alertType: EntityAlertType;
  entityId: string;
}


